module.exports = __webpack_public_path__ + "img/book15.a0b06e2c.jpg";